'use client';

import { FC, useEffect } from 'react';
import { useInitGTM } from 'modules/gtm';
import { useCart } from 'modules/shop/cart/hooks';
import { useUser } from 'modules/shop/user/hooks';
import { useWishlist } from 'modules/shop/wishlist/useWishlist';

export const HooksInitializer: FC = () => {
  useInitGTM();

  const { getCart } = useCart();
  const { getUser } = useUser();
  const { getWishlist } = useWishlist();

  useEffect(() => {
    getCart();
    getUser();
    getWishlist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
